import { useFolderStore } from '@/stores/folderStore'
import { useCallback } from 'react'
import { usePlan } from '@/hooks/use-plan'

/**
 * Hook para centralizar todas as ações que devem ser executadas
 * quando o usuário troca de organização ativa
 * componente responsável: TeamSwitcher
 */
export function useOrganizationSwitchActions() {
  const { setSelectedFolder, setCurrentPage } = useFolderStore()
  const { refreshPlan } = usePlan()

  const executeOrganizationSwitchActions = useCallback(() => {
    setSelectedFolder(null)
    setCurrentPage(1)
    refreshPlan()
  }, [setSelectedFolder, setCurrentPage, refreshPlan])

  return { executeOrganizationSwitchActions }
}